<template>
  <td class = "SelectableGridCell" :class = "{'active': isActive}">
    <a
      href = "#"
      ref = "cell"
      @focus = "activate"
      @click.prevent>
      <slot />
    </a>
  </td>
</template>
<script lang = "babel">
  export default{
    name: 'SelectableGridCell',

    props: {
      row: Number,
      activeRow: Number
    },

    computed: {
      isActive () {
        return this.row === this.activeRow
      }
    },

    watch: {
      isActive () {
        this.focus()
      }
    },

    methods: {
      activate () {
        this.$parent.$emit('activated', {row: this.row})
      },

      focus () {
        if (this.isActive) {
          this.$refs.cell.focus()
        }
      }
    }
  }
</script>
<style lang = "scss">
  .SelectableGridCell {
    a,
    a:hover,
    a:active {
      outline: none;
      display: block;
      height: 100%;
      width: 100%;
      color: #212529;
      text-decoration: none;
    }

    &.active {
      background: #dddddd !important;
    }
  }
</style>



// WEBPACK FOOTER //
// SelectableGridCell.vue?05775827